"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const Index_1 = require("../Index");
const helpers_1 = require("../../lib/helpers");
const InputLabel_1 = __importDefault(require("./Base/InputLabel"));
const FormContext_1 = require("../../contexts/FormContext");
const Icon_1 = __importDefault(require("../Util/Icon"));
const Journey_1 = require("../../lib/Journey");
const Input_1 = __importDefault(require("./Base/Input"));
const InputDiv_1 = __importDefault(require("./Base/InputDiv"));
const withJourney_1 = __importDefault(require("../../hocs/withJourney"));
const InputError_1 = __importDefault(require("./Base/InputError"));
const useInputForm_1 = require("../../hooks/useInputForm");
const FileInput = (props) => {
    var _a, _b, _c;
    const { onChange: propsOnChange, help, accept } = props;
    const { formData } = react_1.useContext(FormContext_1.FormContext);
    const value = (_b = formData[(_a = props.name) !== null && _a !== void 0 ? _a : '']) !== null && _b !== void 0 ? _b : props.value;
    const inputRef = react_1.useRef(null);
    const placeholder = (_c = props.placeholder) !== null && _c !== void 0 ? _c : 'Select a file';
    const [imgSrc, setImgSrc] = react_1.useState(typeof value === 'string' ? value : '');
    const onInputChange = useInputForm_1.useInputFormChange(props);
    react_1.useEffect(() => {
        setImgSrc(typeof value === 'string' ? value : '');
    }, [value]);
    react_1.useEffect(() => {
        if (inputRef.current && !value && inputRef.current.value !== '') {
            // force reset the input file, otherwise uploading the same file again will not trigger an onChange.
            inputRef.current.value = '';
        }
    }, [value]);
    const onClickHandle = react_1.useCallback(() => {
        var _a;
        (_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.click();
    }, []);
    react_1.useEffect(() => {
        if (value instanceof File) {
            const fr = new FileReader();
            fr.readAsDataURL(value);
            fr.addEventListener('load', (e) => {
                if (fr.result) {
                    setImgSrc(fr.result);
                }
            });
            return () => {
                fr.abort();
            };
        }
    }, [value]);
    const clearImg = react_1.useCallback((e) => {
        const inputEvent = helpers_1.createSyntheticChangeEvent(inputRef.current, '');
        // must run before stopPropagation
        onInputChange === null || onInputChange === void 0 ? void 0 : onInputChange(inputEvent);
        e.stopPropagation();
        setImgSrc('');
    }, [onInputChange]);
    const fileName = !helpers_1.isServer() && value instanceof File ? value.name : '';
    return (react_1.default.createElement(InputDiv_1.default, { value: props.value, className: classnames_1.default(props.className, { disabled: props.disabled }), label: props.label, name: props.name, error: props.error },
        react_1.default.createElement("div", { onClick: onClickHandle },
            react_1.default.createElement(InputLabel_1.default, null),
            imgSrc ? (react_1.default.createElement("div", { className: "j-file" },
                react_1.default.createElement("img", { alt: "file input img", className: "j-file-img", src: imgSrc }),
                react_1.default.createElement("div", { className: classnames_1.default('j-file-desc', { 'justify-center': !fileName }) },
                    fileName ? (react_1.default.createElement("span", { className: "j-file-name" }, fileName !== null && fileName !== void 0 ? fileName : 'Image')) : null,
                    react_1.default.createElement(Index_1.Button, { className: "j-file-close-button", onClick: clearImg },
                        react_1.default.createElement(Icon_1.default, { src: Journey_1.Journey.icons().CLOSE }))))) : (react_1.default.createElement(Index_1.Button, { className: "j-placeholder" }, placeholder)),
            help ? (react_1.default.createElement("div", { className: "j-help" }, help)) : null,
            react_1.default.createElement(Input_1.default, Object.assign({}, helpers_1.without(props, ['className', 'value']), { accept: accept, ref: inputRef, onChange: propsOnChange, type: "file" }))),
        react_1.default.createElement(InputError_1.default, null)));
};
exports.default = withJourney_1.default('j-file-input', FileInput);
